import type { AbschnittCElectionCandidate } from "@/lib/abschnittc/AbschnittCElection";

export function abschnittCCandidateName(candidate: AbschnittCElectionCandidate): string {
	const words = [];

	if (candidate.title)
		words.push(candidate.title);

	words.push(candidate.firstName);
	words.push(candidate.lastName);

	if (candidate.extra)
		words.push(candidate.extra);

	return words.join(" ");

}
